import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-footer-privacy',
    templateUrl: './footer-privacy.component.html',
    styleUrls: ['./footer-privacy.component.less']
})
export class FooterPrivacyComponent implements OnInit {
    currentYear: number;
    isExternalTermsOrPrivacy = false;

    constructor(private route: ActivatedRoute) { }

    ngOnInit() {
        this.currentYear = new Date().getFullYear();
        this.isExternalTermsOrPrivacy = this.route.snapshot.data.isExternalTermsOrPrivacy;
    }
}
